<mat-radio-group aria-label="field?.controlName" [formGroup]="parentForm" [formControl]="relatedFormControl" [ngClass]="inlineRadios ? 'inlineRadios' : ''">
  <div *ngFor="let item of getValues()" class="fd-radio-button__option-container">
    <mat-radio-button (change)="handleChange($event)" [value]="item.value" [checked]="item.selected">{{item.label}}</mat-radio-button>
  </div>
  <mat-error *ngIf="hasError"><div *ngFor="let errorMessage of errorMessages">{{errorMessage}}</div></mat-error>
</mat-radio-group>
